/** 风险核对报告屏的纯逻辑（G3，#4604）。取数与风险报告解析复用 `../risk/api`。 */

/** 日报 headline 中与本屏相关的两类（daily-ops-report「异常点名」）。 */
export const RISK_HEADLINE_KINDS = ["风险越界", "风控报告缺失"] as const;

export interface HeadlineItem {
  kind: string;
  strategy_id: string;
  detail: string;
}

/** 取日报里点名所选策略的风险类条目；本屏不另判越界。 */
export function riskHeadline(headline: HeadlineItem[], strategyId: string): HeadlineItem[] {
  return headline.filter((h) => h.strategy_id === strategyId && (RISK_HEADLINE_KINDS as readonly string[]).includes(h.kind));
}
